import { gql } from '@apollo/client'

export const SITEMAP_POST_LIST = gql`
  query sitemapPostList($first: Int, $param: PostQueryInput) {
    squareModule {
      squareAiRegionPage(page: { first: $first }, param: $param) {
        edges {
          node {
            id
          }
        }
      }
    }
  }
`

export const SITEMAP_COMPETITION_LIST = gql`
  query sitemapCompetitionList($first: Int) {
    marketingModule {
      competitionPage(page: { first: $first }) {
        edges {
          node {
            id
          }
        }
      }
    }
  }
`
